module.exports = __webpack_public_path__ + "static/media/aboutus_illustaration.cbbffa73.png";